import React, { useState } from 'react'
import { Typography, Box, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Home, Logout, Person } from '@mui/icons-material'
import { getFilteredMenuItems } from 'services/menu'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import _pick from 'lodash/pick'
import { getAuthLogout } from '../../../services/auth/redux/actions'

const HeaderContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  zIndex: 100,
  background: 'transparent',
})

const ClickableLogoArea = styled(Box)({
  position: 'relative',
  display: 'inline-block',
  cursor: 'pointer',
  paddingRight: '16px',
  '&:hover': {
    opacity: 0.8,
  },
})

const Logo = styled(Box)({
  position: 'absolute',
  left: '16px',
  top: '16px',
  width: '70px',
  height: '70px',
  background: 'linear-gradient(45deg, #00b4b4, #7e4592)',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontFamily: 'inherit',
  fontWeight: 'bold',
  fontSize: '45px',
  lineHeight: '1.2',
  zIndex: 2,
})

const HeaderContent = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '16px 16px 16px 100px', // Space for logo, center vertically
  position: 'relative',
  zIndex: 2,
  minHeight: '70px', // Match logo height
})

const LeftContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  minHeight: '70px', // Match logo height
})

const Headline = styled(Typography)(() => ({
  margin: 0,
  color: '#666',
  fontSize: '18px',
  fontFamily: 'inherit',
  padding: '0',
  textTransform: 'uppercase',
  lineHeight: 1.2,
  position: 'relative',
  zIndex: 2,
}))

const Subheadline = styled(Typography)(() => ({
  margin: 0,
  color: '#666',
  fontSize: '14px',
  padding: '0 0 5px 0',
  lineHeight: 1.2,
  position: 'relative',
  zIndex: 2,
}))

function Appbar ({ username = '', config, auth, getAuthLogout: logoutAction }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    if (open) {
      handleClose()
    } else {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (event, path) => {
    // Allow middle-click, ctrl-click, cmd-click, and right-click to work naturally
    if (event.button === 1 || event.ctrlKey || event.metaKey || event.button === 2) {
      return
    }

    event.preventDefault()
    handleClose()

    if (path === '/logout') {
      logoutAction()
    } else {
      window.location.href = path
    }
  }

  const menuItems = getFilteredMenuItems({ config, auth })

  return (
    <HeaderContainer>
      <ClickableLogoArea onClick={handleClick}>
        <Logo>Aa</Logo>
        <HeaderContent>
          <LeftContent>
            <Headline variant="h1">Admin App</Headline>
            <Subheadline variant="h2">Gaia Administration Services</Subheadline>
          </LeftContent>
        </HeaderContent>
      </ClickableLogoArea>
      <Menu
        id="header-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'header-menu-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem component="a" href="/" onClick={(e) => handleMenuItemClick(e, '/')}>
          <ListItemIcon>
            <Home fontSize="small" />
          </ListItemIcon>
          <ListItemText>Home</ListItemText>
        </MenuItem>
        <MenuItem disabled>
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          <ListItemText>{username}</ListItemText>
        </MenuItem>
        <Divider />
        {menuItems.map((item, index) => (
          <MenuItem
            key={`${index}-menu-${item.label}`}
            component="a"
            href={item.path}
            onClick={(e) => handleMenuItemClick(e, item.path)}
          >
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem component="button" onClick={(e) => handleMenuItemClick(e, '/logout')}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </HeaderContainer>
  )
}

export default compose(
  connectRedux(
    (state) => _pick(state, ['config', 'auth']),
    (dispatch) =>
      bindActionCreators(
        {
          getAuthLogout,
        },
        dispatch,
      ),
  ),
)(Appbar)
